import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Icon,
  IconButton,
  MenuItem,
  Popover,
  Table,
  TableBody,
  tableCellClasses,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  FormGroup,
  Chip,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';

import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import LocalTaxiOutlinedIcon from '@mui/icons-material/LocalTaxiOutlined';
import CommonButton from 'components/commonButton/CommonButton';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';
import ProgressBar from 'components/progressBar/ProgressBar';
import { IOSSwitch, StyledCheckbox } from 'pages/configuration/addCompliance/AddComplianceStyleTab';
import {
  truncateComment,
  getDateFormat,
  getTimeFormat,
  getDateComparision,
  formatCurrency,
  abbreviateNumber,
  isValidTripTime,
} from 'utils/utils';
import RatingStar from 'assets/images/RatingStar.svg';
import editmore from 'assets/images/moreEditIcon.svg';
import deleteicon from 'assets/images/delete.svg';
import active from 'assets/images/active.svg';
import deactive from 'assets/images/deActivate.svg';
import block from 'assets/images/block.svg';
import profile from 'assets/images/ProfileVendor.svg';
import crossBtn from 'assets/images/CrossBtn.svg';
import ReAllot from 'assets/images/Reallot.svg';
import PrintDutySlip from 'assets/images/PrintDuty.svg';
import Preview from 'assets/images/Preview.svg';
import starImg from 'assets/images/smStar.svg';
import Reassign from 'assets/images/blackVehicle.svg';
import FileUpload from 'assets/images/FileUpload.svg';
import { dateFormate } from 'utils/utils';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import labelIcon from 'assets/images/labelIcon.svg';
import PlacardModal from 'components/placardModal/PlacardModal';
import upgradeIcon from 'assets/images/upgrade.svg';
import DownloadIcon from '@mui/icons-material/Download';
import Copy from 'assets/images/copy.svg';
import { getDispatchHighlightThresholds } from 'services/SettingsService';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

import {
  BgWhiteTooltip,
  StyledTableCell,
  StyledTableRow,
  styleimg,
  stylename,
} from './CommonTableStyle';

const CommonTable = (props) => {
  const {
    page,
    rowsPerPage,
    companyTable,
    viewMoreIcon,
    handleChangePage,
    handleChangeRowsPerPage,
    moreIconData,
    handleOperation,
    dispatchTableMain,
    showPagination = true,
    enableTripHighlight,
    showDispatchLegend = false,
    showApprovalAction,
    onApproveEmployee,
  } = props;
  let data = props?.data;

  if (props?.tabName === 'operation' && data?.header) {
    const hasAssignedTo = data.header.some((h) => h.key === 'assignedTo');
    if (!hasAssignedTo) {
      const driverIdx = data.header.findIndex((h) => h.key === 'driverName');
      const assignedToHeader = { label: 'Assigned To', key: 'assignedTo' };

      const newHeader = [...data.header];
      if (driverIdx !== -1) {
        newHeader.splice(driverIdx + 1, 0, assignedToHeader);
      } else {
        newHeader.push(assignedToHeader);
      }

      const newBody =
        data.body?.map((ele) => {
          const subVendor =
            ele?.DriverProfile?.subVendorName ||
            ele?.additionalInfo?.subVendorAssignment?.name ||
            ele?.subVendorCompany?.companyName ||
            ele?.additionalInfo?.subVendorAssignmentAction?.[0]?.subVendorCompanyName ||
            'In-House';
          const assignmentStatus = ele?.additionalInfo?.subVendorAssignmentStatus?.toLowerCase();
          const assignmentStatusLabel = {
            pending: 'Pending',
            accepted: 'Accepted',
            rejected: 'Rejected',
            alloted: 'Allotted',
          }[assignmentStatus];
          const hasSubVendorAssignment =
            ele?.subVendorCompanyId ||
            ele?.additionalInfo?.subVendorAssignment?.subVendorCompanyId ||
            ele?.subVendorCompany ||
            ele?.additionalInfo?.subVendorAssignmentAction?.[0]?.subVendorCompanyId;

          return {
            ...ele,
            assignedTo:
              hasSubVendorAssignment && subVendor !== 'In-House' && assignmentStatusLabel
                ? `${subVendor} (${assignmentStatusLabel})`
                : subVendor,
          };
        }) || [];

      data = {
        ...data,
        header: newHeader,
        body: newBody,
      };
    }

    // ── INJECT PAYMENT STATUS COLUMN FOR BILLING TAB (ONLY FOR FINAL INVOICE) ──
    if (props?.subTabName === 'billing' && props?.tab === 'charged') {
      const hasPaymentStatus = data.header.some((h) => h.key === 'paymentStatus');
      if (!hasPaymentStatus) {
        const statusIdx = data.header.findIndex((h) => h.key === 'status');
        const paymentStatusHeader = {
          label: 'Payment Status',
          key: 'paymentStatus',
        };
        const updatedHeader = [...data.header];
        if (statusIdx !== -1) {
          updatedHeader.splice(statusIdx + 1, 0, paymentStatusHeader);
        } else {
          updatedHeader.push(paymentStatusHeader);
        }

        const updatedBody =
          data.body?.map((ele) => ({
            ...ele,
            paymentStatus:
              ele?.Payments?.[0]?.status || ele?.Payment?.[0]?.status || ele?.paymentStatus || '',
          })) || [];

        data = {
          ...data,
          header: updatedHeader,
          body: updatedBody,
        };
      }
    }
  }

  const navigate = useNavigate();
  const location = useLocation();
  const pageName = location?.pathname?.split('/')[1];

  // const userRole = localStorage.getItem('role');
  const userRole = JSON?.parse(localStorage.getItem('user'));

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [previewModal, setPreviewModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [selectedTripId, setSelectedTripId] = useState('');

  const [thresholds, setThresholds] = useState({
    amberHours: 4,
    redHours: 2,
  });

  useEffect(() => {
    if (!enableTripHighlight || !showDispatchLegend) return;

    const fetchThresholds = async () => {
      const res = await getDispatchHighlightThresholds();

      if (res?.data?.success) {
        setThresholds(res.data.data);
      }
    };

    fetchThresholds();
  }, [enableTripHighlight, showDispatchLegend]);

  // ----FormatingDate---
  const handleDateFormating = (data) => {
    return getDateFormat(data);
  };

  //---Time Format---
  const handleTimeFormat = (data) => {
    return getTimeFormat(data);
  };

  const handleMenuOpen = (event, row) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const onClickTableRow = (event, val) => {
    event.preventDefault();
    event.stopPropagation();
    if (props?.from) {
      props?.onClickId(val, props?.from);
    } else {
      props?.tableOnClickRow(navigate, val);
    }
  };

  const statusAction = ['Alloted', 'Booked'];
  const handleMouseOver = (id, status, row) => {
    const role = localStorage?.getItem('role');

    if (
      statusAction.includes(status) &&
      pageName === 'operation' &&
      props?.accessForOperations &&
      actionButton(status, row)
    ) {
      const textDom = document.getElementById(`status-text-${id}`);
      textDom.classList.add('disableText');
      const btnDom = document.getElementById(`statusBtn-${id}`);
      btnDom.classList.add('activeBtn');
    }
  };

  const handlePreviewOpen = (placardText, id, e) => {
    e.stopPropagation();
    if (id) {
      setSelectedTripId(id);
      setPreviewModal(true);
    }
  };

  const handlePreviewClose = () => {
    setSelectedImage('');
    setPreviewModal(false);
  };

  const handleMouseLeave = (id, status, row) => {
    const role = localStorage?.getItem('role');
    if (
      statusAction.includes(status) &&
      pageName === 'operation' &&
      props?.accessForOperations &&
      actionButton(status, row)
    ) {
      const textDom = document.getElementById(`status-text-${id}`);
      textDom.classList.remove('disableText');
      const btnDom = document.getElementById(`statusBtn-${id}`);
      btnDom.classList.remove('activeBtn');
    }
  };

  const actionButton = (status, ele) => {
    // If assigned to a sub-vendor, hide the action button (Allot/Dispatch) completely
    if (
      (ele?.subVendorCompanyId ||
        ele?.additionalInfo?.subVendorAssignment?.subVendorCompanyId ||
        ele?.subVendorCompany ||
        ele?.additionalInfo?.subVendorAssignmentStatus === 'alloted') &&
      ele?.additionalInfo?.subVendorAssignmentStatus !== 'rejected'
    ) {
      return null;
    }

    switch (status?.toLowerCase()) {
      case 'booked':
        return (
          <CommonButton
            onClick={(event) => handleOperation(event, status, ele)}
            name={'Allot'}
            btnClass={'btnGreen btnXtraSmall'}
          />
        );
      case 'alloted':
        return (
          <CommonButton
            onClick={(event) => handleOperation(event, status, ele)}
            name={'Dispatch'}
            btnClass={'btnYellow btnXtraSmall'}
          />
        );
      case 'dispatched':
        if (props?.tabName === 'operation' && props?.onMarkNoShow) {
          return (
            <CommonButton
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                props.onMarkNoShow(ele);
              }}
              name={'Mark No-Show'}
              btnClass={'btnRed btnXtraSmall'}
            />
          );
        }
        return null;
      default:
        return (
          <CommonButton
            onClick={(event) => handleOperation(event, status, ele)}
            name={'Allot'}
            btnClass={'btnGreen btnXtraSmall'}
          />
        );
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const getConditionalMenuItems = (status, isIndividual, hasExtensionRequest, row) => {
    // Disable all actions for post-trip statuses
    const postTripStatus = ['completed', 'cancelled'];
    const tripStatus = status?.toLowerCase()?.trim();

    if (postTripStatus?.includes(tripStatus)) {
      return [];
    }

    if (props?.tabName === 'cabCategory' || props?.tabName === 'feedback') {
      switch (status?.toLowerCase()) {
        case 'active':
          return ['Edit', 'Deactivate'];
        case 'inactive':
          return ['Activate'];
        case 'blocked':
          return ['Unblock'];
        default:
          return ['Edit'];
      }
    } else if (props?.tabName === 'driver') {
      switch (status?.toLowerCase()) {
        case 'active':
          return ['Edit', 'Deactivate', 'Upload Compliance', 'Block'];
        case 'inactive':
          return ['Activate', 'Block'];
        case 'blocked':
          return ['Unblock'];
        case 'pending':
          return ['Upload Compliance'];
        default:
          return ['Edit', 'Upload Compliance'];
      }
    } else if (props.tabName === 'vehicle') {
      switch (status?.toLowerCase()) {
        case 'active':
          return ['Edit', 'Deactivate', 'Upload Compliance'];
        case 'inactive':
          return ['Activate'];
        case 'blocked':
          return ['Unblock'];
        case 'Pending':
          return ['Upload Compliance', 'Edit'];
        default:
          return ['Upload Compliance'];
      }
    } else if (props?.tabName === 'compliance') {
      return ['Edit'];
    } else if (props?.tabName === 'companyData') {
      return ['Renew'];
    } else if (props?.tabName === 'company') {
      switch (status?.toLowerCase()) {
        case 'active':
          return ['Edit', 'Inactive'];
        case 'inactive':
          return ['Edit', 'Active'];
        case 'pending':
          if (props?.tabName === 'customer') {
            return [];
          } else {
            return ['Edit'];
          }
        default:
          return [];
      }
    } else if (props?.tabName === 'reservation') {
      switch (status?.toLowerCase()) {
        case 'booked':
        case 'alloted':
        case 'pending':
          return props.accessForEdit
            ? ['Edit']
            : props.accessForCancel
              ? ['Cancel Duty']
              : ['Edit', 'Cancel Duty'];
        case 'dispatched':
          return props.accessForCancel || props.accessForall ? ['Cancel Duty'] : [];
        case 'ongoing':
          return ['Update Status'];
        case 'closed':
          return ['Update Status'];
        default:
          return [];
      }
    } else if (props?.tabName === 'operation') {
      // Check for extension request (takes priority over normal status)
      if (hasExtensionRequest) {
        return ['Approve Extension', 'Provision New Trip'];
      }

      switch (status?.toLowerCase()) {
        case 'ongoing':
          // For ongoing with extension request, show extension options
          if (hasExtensionRequest) {
            return ['Approve Extension', 'Provision New Trip'];
          }
          return [];
        case 'booked':
        case 'pending':
          return props.accessForCancel || props.accessForall ? ['Cancel Duty'] : [];
        case 'dispatched':
        case 'alloted': {
          const isAssignedToSubVendor =
            (row?.subVendorCompanyId ||
              row?.additionalInfo?.subVendorAssignment?.subVendorCompanyId ||
              row?.subVendorCompany ||
              row?.additionalInfo?.subVendorAssignmentStatus === 'alloted') &&
            row?.additionalInfo?.subVendorAssignmentStatus !== 'rejected';

          if (isAssignedToSubVendor) {
            return props.accessForCancel || props.accessForall ? ['Cancel Duty'] : [];
          }

          return props?.accessForAllotAndCancel
            ? ['Re-Allot', 'Cancel Duty']
            : props?.accessForReallot
              ? ['Re-Allot']
              : props.accessForCancel
                ? ['Cancel Duty']
                : [];
        }
        case 'dispute':
          return props?.accessForGenerate
            ? ['Duty Slip', 'Proforma Invoice', 'Regenerate']
            : ['Duty Slip', 'Proforma Invoice'];
        case 'approvalforcharge':
          return ['Duty Slip', 'Proforma Invoice'];
        case 'charged':
          return isIndividual ? ['Individual Invoice'] : ['Consolidated Invoice'];
        default:
          return [];
      }
    } else if (props?.tabName === 'unAssignTab') {
      return ['Reassign', 'Unassign'];
    } else if (props?.tabName === 'coupon') {
      switch (status?.toLowerCase()) {
        case 'active': {
          const options = ['Deactivate', 'Delete', 'Copy Coupon'];
          if (row?.isBanner) {
            options.push('+ Add to highlight');
          }
          return options;
        }

        case 'inactive':
          return ['Edit', 'Activate', 'Copy Coupon', 'Delete'].filter(
            (item) => item !== 'Edit' || row?.isDraft,
          );
        case 'draft':
          return ['Edit', 'Copy Coupon', 'Delete'];
        default:
          return ['Edit', 'Copy Coupon', 'Delete'].filter(
            (item) => item !== 'Edit' || row?.isDraft,
          );
      }
    } else {
      switch (status?.toLowerCase()) {
        case 'active':
          if (props?.tabName === 'customer') {
            return ['Block'];
          } else {
            return ['Edit', 'Deactivate', 'Block'];
          }
        case 'inactive':
          return ['Activate', 'Block'];
        case 'blocked':
          return ['Unblock'];
        case 'pending':
          if (props?.tabName === 'customer') {
            return [];
          } else {
            return ['Edit'];
          }
        default:
          return [];
      }
    }
  };

  const onClickMoreIcon = (event, data, type) => {
    event.preventDefault();
    event.stopPropagation();
    props?.onClickMoreIcon(data, type);
    handleMenuClose(); // Close the menu after handling the action
  };

  const handlePreview = (event, id, type) => {
    event.preventDefault();
    event.stopPropagation();
    props?.onHandlePreview(id, type);
  };

  const moreIconSrc = (value) => {
    switch (value?.toLowerCase()) {
      case 'blocked':
      case 'block':
      case 'unblock':
        return block;
      case 'upload compliance':
        return FileUpload;
      case 'edit':
      case 'renew':
      case 'regenerate':
        return editmore;
      case 'active':
      case 'activate':
        return active;
      case 'inactive':
      case 'deactivate':
        return deactive;
      case 'delete':
        return deleteicon;
      case 'copy coupon':
        return Copy;
      case 'cancel duty':
      case 'unassign':
        return crossBtn;
      case 'print duty slip':
        return PrintDutySlip;
      case 're-allot':
        return ReAllot;
      case 'update status':
        return editmore;
      case 'preview':
      case 'consolidated invoice':
      case 'duty slip':
      case 'proforma invoice':
      case 'individual invoice':
        return Preview;
      case 'reassign':
        return Reassign;
      case 'approve extension':
        return <VerifiedOutlinedIcon />;
      case 'provision new trip':
        return <LocalTaxiOutlinedIcon />;
      case 'assign new driver':
        return <LocalTaxiOutlinedIcon />;
      default:
        return;
    }
  };

  const handleCheckboxChange = (row) => {
    props?.handleCheckboxChange(row, data?.body);
  };

  const handleSelectAllCheckboxChange = () => {
    props?.handleSelectAllCheckboxChange(data?.body);
  };

  const onClickTableVendor = (val) => {
    if (props?.from) {
      props?.onClickId(val, props?.from);
    } else {
      props?.onClickTableVendor(val);
    }
  };

  const onCheckChange = (e, ele, key, index) => {
    props?.onCheckChange(ele, key, index);
  };
  //disable Edit option
  const handleDisableEdit = (tabName, icon, time) => {
    console.log(time, 'time');
    if (tabName === 'reservation' && icon === 'Edit' && !isValidTripTime(time)) {
      return true;
    }
  };

  //disable moreVertIcn

  const handleMoreVertIcon = (status, viewMoreIcon, hasExtensionRequest, row) => {
    const tripStatus = status?.toLowerCase();
    const postTripStatus = ['completed', 'cancelled', 'ongoing', 'closed'];

    // Show menu for extension requests in operation tab (especially for multi-day bookings with ongoing status)
    if (hasExtensionRequest && props?.tabName === 'operation') {
      return 'accessForExtension';
    }

    // For 'ongoing' status, only hide menu for non-extension requests
    if (tripStatus === 'ongoing') {
      // Allow menu for ongoing with extension request
      if (hasExtensionRequest) {
        return 'accessForExtension';
      }
      return false;
    } else if (postTripStatus?.includes(tripStatus)) {
      return false;
    } else if (!viewMoreIcon) {
      if (props?.tabName === 'reservation') {
        if ((!props.accessForCancel || !props.accessForall) && tripStatus !== 'dispatched') {
          return 'nonDispatch';
        }

        if (tripStatus === 'dispatched' && userRole?.subRole === 'Admin') {
          return 'dispatch';
        }
      } else if (props?.tabName === 'operation') {
        if (tripStatus === 'booked' || tripStatus === 'pending') {
          return props?.accessForCancel ? 'accessForBooking' : false;
        } else if (tripStatus === 'alloted' || tripStatus === 'dispatched') {
          return props?.accessForCancel || props?.accessForReallot ? 'accessForAllot' : false;
        } else if (props?.subTabName === 'billing') {
          return 'accessForViewInvoices';
        } else {
          return false;
        }
      } else if (props?.tabName === 'company') {
        return 'accessForEdit';
      } else if (
        props?.tabName === 'subVendorTable' ||
        props?.tabName === 'driver' ||
        props?.tabName === 'vehicle' ||
        props?.tabName === 'cabCategory' ||
        props?.tabName === 'compliance' ||
        props?.tabName === 'feedback' ||
        props?.tabName === 'companyData' ||
        props?.tabName === 'unAssignTab' ||
        props?.tabName === 'coupon'
      ) {
        return 'accessForEdit';
      }
    }
  };

  const getTripWarningClass = (trip) => {
    if (trip?.status?.toLowerCase() === 'cancelled') {
      return '';
    }

    const noVehicle = !trip?.driverId;

    const amberHours = thresholds?.amberHours ?? 4;
    const redHours = thresholds?.redHours ?? 2;

    const scheduledTime = new Date(trip?.scheduledTime);
    const currentTime = new Date();

    const hoursToPickup = (scheduledTime.getTime() - currentTime.getTime()) / (1000 * 60 * 60);

    if (!noVehicle || isNaN(hoursToPickup)) {
      return '';
    }

    if (hoursToPickup >= 0 && hoursToPickup <= redHours) {
      return 'row-red';
    }

    if (hoursToPickup > redHours && hoursToPickup <= amberHours) {
      return 'row-amber';
    }

    return '';
  };

  const shouldAlignCenter = (key) => {
    return key === 'isActive' || key === 'isMandatory' || key === 'isExpiring';
  };

  const textTruncate = (key) => {
    return (
      key === 'sourceAddress' ||
      key === 'pickupAddress' ||
      key === 'companyAddress' ||
      key === 'empId' ||
      key === 'sourceLandMarkAddress'
    );
  };

  function BannerIcon({ size = 24, color = 'currentColor', className = '' }) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={{ marginLeft: '8px' }}
      >
        {/* Banner rectangle */}
        <rect
          x="2"
          y="6"
          width="20"
          height="12"
          rx="2"
          stroke={color}
          strokeWidth="2"
          fill="none"
        />

        {/* Banner content lines */}
        <line
          x1="6"
          y1="10"
          x2="18"
          y2="10"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />

        <line
          x1="6"
          y1="14"
          x2="14"
          y2="14"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />

        {/* Banner flag/ribbon effect */}
        <path
          d="M22 6L20 8L22 10V6Z"
          fill={color}
          stroke={color}
          strokeWidth="1"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  const amberHours = thresholds?.amberHours ?? 4;
  const redHours = thresholds?.redHours ?? 2;

  return (
    <div>
      {showDispatchLegend && (
        <div className="tripHighlightLegend">
          <span className="legendItem">
            <span className="legendColor amber"></span>
            No vehicle assigned, pickup within {amberHours}h
          </span>

          <span className="legendItem">
            <span className="legendColor red"></span>
            No vehicle assigned, pickup within {redHours}h
          </span>
        </div>
      )}

      <TableContainer
        className={`tableMain 
        ${dispatchTableMain && 'dispatchTableMain'}
       `}
      >
        <Table
          sx={{ [`& .${tableCellClasses.root}`]: { borderBottom: 'none' } }}
          aria-label="customized table"
        >
          <TableHead className="tableborder">
            <TableRow className="commonTableRow">
              {data?.header?.map((ele, index) => (
                <StyledTableCell
                  key={index}
                  align={shouldAlignCenter(ele.key) ? 'center' : 'left'}
                  className={`comColumnWidth font16 fw500 ${
                    ele.key === 'editIcon' && 'editIconColumn'
                  } ${
                    ele.className
                      ? 'iconColumn'
                      : ele.key === 'dropping' || ele.key === 'comment'
                        ? 'font14'
                        : ''
                  } ${ele.key === 'check' && !props?.accessForGenerate && 'removingCheckbox'}`}
                >
                  {ele.key === 'check' && props?.accessForGenerate ? (
                    <Checkbox
                      className="headerOutlinedCheckbox"
                      icon={<CheckBoxOutlineBlankIcon />}
                      checkedIcon={<CheckBoxOutlinedIcon />}
                      checked={props?.selectAllChecked}
                      onChange={handleSelectAllCheckboxChange}
                    />
                  ) : (
                    ele?.label
                  )}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="tableBodyStyle">
            {data?.body && data?.body?.length > 0 ? (
              data?.body?.map((ele, ind) => (
                <StyledTableRow
                  key={ind}
                  onClick={(event) =>
                    props?.isClickable ? onClickTableRow(event, ele) : undefined
                  }
                  role={props?.isClickable ? 'presentation' : ''}
                  disabled={ele.status === 'Blocked'}
                  className={`comRowChildWidth clickableRow
                      ${companyTable && 'companyTable'} font18 ${
                        ele?.isVip && ele?.isVip !== 'No' && ele?.isVip !== 'Yes' && 'vip'
                      } ${ele.gender === 'Female' && 'female'}
                      ${enableTripHighlight && getTripWarningClass(ele)}`}
                >
                  {data?.header?.map((val, index) => (
                    <StyledTableCell
                      align={shouldAlignCenter(val?.key) ? 'center' : 'left'}
                      key={index}
                      disabled={ele.status === 'Blocked'}
                      className={`${val.key === 'status' && 'status-td'} ${
                        props?.minWidth === true && 'minWidth130'
                      } ${val.key === 'check' && !props?.accessForGenerate && 'removingCheckbox'}`}
                    >
                      {val.key === 'title' ? (
                        <Box style={styleimg}>
                          <Tooltip title={ele[val.key]} placement="top" arrow>
                            <span style={{ cursor: 'pointer' }}>
                              {ele[val.key]?.length > 10
                                ? `${ele[val.key].substring(0, 10)}...`
                                : ele[val.key]}
                            </span>
                          </Tooltip>
                          {/* Show banner icon if it's a banner */}
                          {ele?.isBanner && (
                            <Tooltip title="Banner Coupon" placement="top">
                              <BannerIcon size={20} color="#3B82F6" />
                            </Tooltip>
                          )}
                          {/* Show draft indicator */}
                          {ele?.status === 'Draft' && (
                            <Chip
                              label="Draft"
                              size="small"
                              sx={{
                                marginLeft: '8px',
                                backgroundColor: '#E5E7EB',
                                color: '#4B5563',
                                fontWeight: 500,
                              }}
                            />
                          )}
                        </Box>
                      ) : val.label === 'Trip Date' ? (
                        <Box>
                          <Typography variant={'body2'}>
                            {ele['scheduledTime']
                              ? handleDateFormating(ele['scheduledTime'])
                              : ele['tripDate'] || 'NA'}
                          </Typography>
                        </Box>
                      ) : val.key === 'dutyTypeName' ? (
                        <Box>
                          <Typography variant={'body2'}>
                            {ele[val.key]}
                            {(ele?.additionalInfo?.isMultiDay || ele?.isMultiDay) && (
                              <span className="font12 fontNormal colorGrey">{' (Multi-day)'}</span>
                            )}
                          </Typography>
                        </Box>
                      ) : val.key === 'tripType' ? (
                        <Box>
                          <Typography variant={'body2'}>
                            {ele[val.key]}
                            {ele?.TripsV3?.additionalInfo?.isMultiDay && (
                              <span className="font12 fontNormal colorGrey">{' (Multi-day)'}</span>
                            )}
                          </Typography>
                        </Box>
                      ) : val.key === 'dutyTypes' ? (
                        <Box>
                          <Typography variant={'body2'}>
                            {ele[val.key]}
                            {ele?.Invoices?.[0]?.TripsV3?.additionalInfo?.isMultiDay && (
                              <span className="font12 fontNormal colorGrey">{' (Multi-day)'}</span>
                            )}
                          </Typography>
                        </Box>
                      ) : val.key === 'check' && props?.accessForGenerate ? (
                        <Checkbox
                          className="bodyOutlinedCheckbox"
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxOutlinedIcon />}
                          checked={
                            props?.selectAllChecked ||
                            props?.selectedCheckRows?.some(
                              (selectedRow) => selectedRow?.id === ele?.id,
                            )
                          }
                          onChange={() => handleCheckboxChange(ele)}
                        />
                      ) : val.label === 'Reporting Time' ? (
                        <Box>
                          <Typography variant={'body2'}>
                            {handleTimeFormat(ele['scheduledTime'])}
                          </Typography>
                        </Box>
                      ) : textTruncate(val?.key) ? (
                        <Box>
                          <Tooltip title={ele[val.key]} placement="bottom">
                            <Typography
                              variant={'body2'}
                              className={`${ele[val.key] === 'NA' && 'colorGrey'}`}
                            >
                              {ele[val.key] ? truncateComment(ele[val.key], 15) : 'NA'}
                            </Typography>
                          </Tooltip>
                        </Box>
                      ) : val.key === 'destinationAddress' ? (
                        <Box>
                          <Tooltip title={ele?.destinationAddress} placement="bottom">
                            <Typography
                              variant={'body2'}
                              className={`${ele?.destinationAddress === 'NA' && 'colorGrey'}`}
                            >
                              {ele?.destinationAddress
                                ? truncateComment(ele?.destinationAddress, 15)
                                : 'NA'}
                            </Typography>
                          </Tooltip>
                        </Box>
                      ) : val.key === 'expiryDate' ? (
                        dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                      ) : val.key === 'createdAt' ? (
                        dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                      ) : val.key === 'daysToExpire' ? (
                        ele[val.key] < 0 ? (
                          <Typography color="error">Expired</Typography>
                        ) : (
                          <Typography className="colorOrangeText">{ele[val.key]} days</Typography>
                        )
                      ) : val.key === 'completedAt' ? (
                        dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                      ) : val.key === 'expiresAt' ? (
                        dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                      ) : val.key === 'tripId' ? (
                        <Box>
                          <Typography variant={'body2'}>{ele[val.key]}</Typography>
                        </Box>
                      ) : val.key === 'date' || val?.key === 'updatedAt' ? (
                        <Box>
                          <Typography variant={'body2'}>
                            {ele[val.key] !== null && getDateFormat(ele[val.key])}
                          </Typography>
                        </Box>
                      ) : val.key === 'action' && props?.assignBtnAccess ? (
                        <Button
                          className={`textTransformInherit fontNormal ${ele.action + 'Btn'}`}
                          variant="contained"
                          onClick={() => {
                            onClickTableVendor(ele);
                          }}
                        >
                          {ele[val.key]}
                        </Button>
                      ) : val.key === 'icon' &&
                        getConditionalMenuItems(
                          ele?.status,
                          ele?.isIndividual,
                          ele?.hasExtensionRequest,
                          ele,
                        )?.length > 0 ? (
                        <div className="floatRight">
                          <IconButton onClick={(event) => handleMenuOpen(event, ele)}>
                            <div className="colorBlack">{<MoreVertIcon />}</div>
                          </IconButton>
                        </div>
                      ) : val.key === 'price' ||
                        val.key === 'totalAmount' ||
                        val.key === 'amountSettled' ||
                        val.key === 'outstandingAmount' ? (
                        <Box>
                          <Tooltip
                            title={'₹' + (Number(ele[val.key]) || 0)}
                            placement="bottom-start"
                          >
                            <Typography variant={'body2'}>
                              {ele?.[val.key] && '₹'}&nbsp;
                              {abbreviateNumber(Number(ele[val.key]) || 0)}
                            </Typography>
                          </Tooltip>
                        </Box>
                      ) : val.key === 'carModel' ? (
                        <Box display={'flex'} onClick={(event) => onClickTableRow(event, ele)}>
                          <Box className="pl10">
                            <Typography variant={'body2'}>{ele['carModel']}</Typography>
                          </Box>
                        </Box>
                      ) : val.key === 'expiryDate' ? (
                        <Box display={'flex'} onClick={(event) => onClickTableRow(event, ele)}>
                          <Box className="pl10">
                            <Typography variant={'body2'}>{ele['expiryDate']}</Typography>
                            <Typography variant={'body3'} className="colorRed">
                              {ele['countDown']} Days
                            </Typography>
                          </Box>
                        </Box>
                      ) : val.key === ele['imageflag'] ? (
                        <Box className="alignStart">
                          {val.key === ele['imageflag'] && (
                            <Avatar
                              className="wh38 mr10"
                              src={ele?.avtar?.url ? ele?.avtar?.url : profile}
                              alt="vendorimage"
                            />
                          )}
                          <span>
                            <Tooltip title={ele[val.key]} placement="bottom">
                              {truncateComment(ele[val.key], 20)}
                            </Tooltip>{' '}
                            <br />
                            {ele?.category && (
                              <span className="font12 fontNormal colorGrey">{ele.category}</span>
                            )}
                          </span>
                        </Box>
                      ) : (val.key === 'name' && ele['imageflag'] === 'name') ||
                        (val.key === 'companyName' && ele['imageflag'] === 'companyName') ||
                        (val.key === 'fullName' && ele['imageflag'] === 'fullName') ||
                        (val.key === 'carType' && ele['imageflag'] === 'carType') ? (
                        <Box
                          display={'flex'}
                          alignItems={'center'}
                          onClick={(event) => onClickTableRow(event, ele)}
                        >
                          <Avatar
                            alt="Maruti"
                            src={ele?.avtar?.url ? ele?.avtar?.url : profile}
                            className="wh38"
                          />
                          <Typography variant={'body2'} className="pl20">
                            {ele['imageflag'] === 'name' ? ele['name'] : ele['companyName']}
                          </Typography>
                        </Box>
                      ) : val.key === ele['currencyFlag'] ? (
                        <Box>
                          <Tooltip
                            title={'₹' + (Number(ele[val.key]) || 0)}
                            placement="bottom-start"
                          >
                            <Typography variant="body2">
                              {ele?.[val.key] && '₹'}&nbsp;
                              {abbreviateNumber(Number(ele[val.key]) || 0)}
                            </Typography>
                          </Tooltip>
                        </Box>
                      ) : val.key === 'carType' ? (
                        <Box>
                          <div className="flex items-center gap-2">
                            {ele?.additionalInfo?.isUpgrade && (
                              <Tooltip title="Upgraded" placement="bottom-start">
                                <img src={upgradeIcon} alt="upgradeIcon" className="w-8 h-8" />
                              </Tooltip>
                            )}
                            <div>
                              <div>{ele[val.key]}</div>
                              <div className="font12 colorGrey">{ele.regNumber}</div>
                            </div>
                          </div>
                        </Box>
                      ) : val.key === 'gstNumber' ? (
                        <Box className="gstField widthMaxcontent">
                          {ele?.gstNumber?.length > 0 && (
                            <BgWhiteTooltip
                              title={
                                ele?.gstNumber?.length > 0
                                  ? ele?.gstNumber?.map((number, idx) => (
                                      <Typography
                                        variant="body3"
                                        component={'p'}
                                        key={idx}
                                        className="colorBlack"
                                      >
                                        {number?.toUpperCase()}
                                      </Typography>
                                    ))
                                  : 'NA'
                              }
                              placement="bottom"
                            >
                              <Typography variant={'body2'}>
                                {ele?.gstNumber?.length > 0 ? (
                                  ele?.gstNumber?.length === 1 ? (
                                    ele?.gstNumber?.[0]?.toUpperCase()
                                  ) : (
                                    <>
                                      {ele?.gstNumber?.[0]?.toUpperCase()}
                                      <span className="tableCount ml5">
                                        <Typography variant="body3" component={'span'}>
                                          + {ele?.gstNumber?.length - 1}
                                        </Typography>
                                      </span>
                                    </>
                                  )
                                ) : (
                                  'NA'
                                )}
                              </Typography>
                            </BgWhiteTooltip>
                          )}
                          {!ele?.gstNumber?.length && <Typography variant={'body2'}>NA</Typography>}
                        </Box>
                      ) : val.key === 'documentStatus' ? (
                        <Box>
                          <div className="progressAlign">
                            <span className="tableProgressBar">
                              <ProgressBar
                                approvedCount={ele?.ApprovedCount}
                                rejectCount={ele?.rejectCount}
                                totalRequired={ele?.totalRequired}
                              />
                            </span>
                            <span className="tableProgressBarText">{ele[val.key]}</span>
                          </div>
                        </Box>
                      ) : val.key === 'customerName' ? (
                        <Box display="flex" alignItems="center" gap={1}>
                          <Box display="flex" alignItems="center" maxWidth="102px">
                            <Tooltip title={ele[val.key]} placement="bottom">
                              <Typography
                                variant={'body2'}
                                sx={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '100px',
                                  fontWeight: 500,
                                }}
                              >
                                {ele[val.key]}
                              </Typography>
                            </Tooltip>
                            {ele?.additionalInfo?.placard?.text && (
                              <Tooltip title="View Placard" placement="bottom">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handlePreviewOpen(
                                      ele?.additionalInfo?.placard?.text,
                                      ele?.id,
                                      e,
                                    );
                                  }}
                                  sx={{ padding: '4px' }}
                                >
                                  <img
                                    src={labelIcon}
                                    alt="Placard"
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                          {ele.complainType === 'sos' && (
                            <span className="inline-flex px-[10px] py-[4px] justify-center items-center gap-[10px] rounded-[8px] bg-[#F2C7C7] text-[#950000] font-openSans text-[12px] font-normal leading-none">
                              SOS
                            </span>
                          )}
                        </Box>
                      ) : val.key === 'downloadLink' &&
                        ele[val.key] &&
                        ele[val.key].trim() !== '' ? (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (ele.downloadLink) {
                              window.open(ele.downloadLink, '_blank');
                            }
                          }}
                        >
                          <DownloadIcon />
                        </IconButton>
                      ) : val.key === 'reportName' ? (
                        <Tooltip title={ele[val.key]} placement="bottom" arrow>
                          <Typography
                            sx={{
                              whiteSpace: 'normal',
                              wordBreak: 'break-word',
                              fontSize: '14px',
                              fontWeight: 400,
                              lineHeight: 1.4,
                            }}
                          >
                            {ele[val.key]}
                          </Typography>
                        </Tooltip>
                      ) : val.key === 'category' ? (
                        <Tooltip title={ele[val.key]} placement="bottom" arrow>
                          <Typography
                            sx={{
                              whiteSpace: 'normal',
                              wordBreak: 'break-word',
                              fontSize: '14px',
                              lineHeight: 1.4,
                            }}
                          >
                            {ele[val.key]}
                          </Typography>
                        </Tooltip>
                      ) : val.key === 'completedAt' ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          <Typography
                            sx={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              fontSize: '14px',
                            }}
                          >
                            {ele[val.key]}
                          </Typography>
                        </Tooltip>
                      ) : val.key === 'expiresAt' ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          <Typography
                            sx={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              fontSize: '14px',
                            }}
                          >
                            {ele[val.key]}
                          </Typography>
                        </Tooltip>
                      ) : val.key === 'paymentStatus' ? (
                        <Typography
                          variant="body2"
                          className="textCapitalize"
                          sx={{
                            color:
                              {
                                success: '#2E7D32', // green
                                paid: '#2E7D32',
                                pending: '#ED6C02', // orange
                                failed: '#D32F2F', // red
                                declined: '#D32F2F',
                                unpaid: '#D32F2F', // red
                              }[ele[val.key]?.toLowerCase()] || '#757575', // grey fallback for null/NA/unknown
                            fontWeight: 500,
                          }}
                        >
                          {ele[val.key] || 'NA'}
                        </Typography>
                      ) : val.key === 'status' ||
                        val.key === 'approvalStatus' ||
                        val.key === 'isApproved' ||
                        val?.key === 'assignStatus' ? (
                        <Box
                          className="statusBtn"
                          onMouseEnter={() => handleMouseOver(ind, ele[val.key], ele)}
                          onMouseLeave={() => handleMouseLeave(ind, ele[val.key], ele)}
                        >
                          {' '}
                          {props?.tabName === 'operation' && ele?.isRegenerated ? (
                            <Box>
                              <Typography
                                variant={'body2'}
                                className={'textCapitalize colorSecondary'}
                              >
                                {'PendingApproval'}
                              </Typography>
                              <Typography
                                component="span"
                                variant="body5"
                                className="textCapitalize"
                              >
                                (Regenerated Invoice)
                              </Typography>
                            </Box>
                          ) : (
                            <Box>
                              <Typography
                                variant={'body2'}
                                id={`status-text-${ind}`}
                                className={`${
                                  ele?.hasExtensionRequest
                                    ? 'extension requested'
                                    : ele.status
                                      ? ele.status?.toLowerCase()
                                      : ele.isApproved
                                        ? ele?.isApproved
                                        : ele?.assignStatus?.toLowerCase()
                                }Status textCapitalize`}
                                sx={{
                                  color:
                                    ele[val.key]?.toLowerCase() === 'ongoing'
                                      ? '#6665DD'
                                      : 'inherit',
                                }}
                              >
                                {ele[val.key]}
                              </Typography>

                              {/* Display extension status below */}
                              {(ele?.hasExtensionRequest || ele?.additionalInfo?.tripExtended) && (
                                <Typography
                                  variant={'caption'}
                                  sx={{
                                    display: 'block',
                                    color: ele?.hasExtensionRequest ? '#ff1717' : '#4caf50',
                                    fontSize: '0.75rem',
                                    marginTop: '2px',
                                  }}
                                >
                                  {ele?.hasExtensionRequest ? 'Extension Request' : 'Extended'}
                                </Typography>
                              )}

                              {/* Sub-vendor assignment badge — shows when trip is assigned to a supplier */}
                              {props?.tabName === 'operation' &&
                                (ele?.additionalInfo?.subVendorAssignment?.name ||
                                  ele?.subVendorCompany?.companyName) &&
                                ele?.additionalInfo?.subVendorAssignmentStatus !== 'rejected' && (
                                  <Typography
                                    variant={'caption'}
                                    sx={{
                                      display: 'block',
                                      color: '#7b5ea7',
                                      fontSize: '0.72rem',
                                      fontWeight: 600,
                                      marginTop: '3px',
                                      lineHeight: 1.3,
                                    }}
                                  >
                                    🏢{' '}
                                    {ele?.additionalInfo?.subVendorAssignment?.name ||
                                      ele?.subVendorCompany?.companyName}
                                    {(ele?.additionalInfo?.subVendorAssignment?.city ||
                                      ele?.subVendorCompany?.location) && (
                                      <span
                                        style={{
                                          fontWeight: 400,
                                          color: '#888',
                                        }}
                                      >
                                        {' '}
                                        &middot;{' '}
                                        {ele?.additionalInfo?.subVendorAssignment?.city ||
                                          ele?.subVendorCompany?.location}
                                      </span>
                                    )}
                                  </Typography>
                                )}

                              {/* Show rejection status and reason if rejected by sub-vendor */}
                              {props?.tabName === 'operation' &&
                                ele?.additionalInfo?.subVendorAssignmentStatus === 'rejected' && (
                                  <Box sx={{ mt: 0.5 }}>
                                    <Typography
                                      variant={'caption'}
                                      sx={{
                                        display: 'block',
                                        color: '#ff1717',
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                        lineHeight: 1.3,
                                      }}
                                    >
                                      ❌ Rejected by Sub-vendor
                                      {ele?.additionalInfo?.subVendorAssignment?.name &&
                                        ` (${ele.additionalInfo.subVendorAssignment.name})`}
                                    </Typography>
                                    {ele?.additionalInfo?.subVendorRejectedReason && (
                                      <Typography
                                        variant={'caption'}
                                        sx={{
                                          display: 'block',
                                          color: '#d32f2f',
                                          fontSize: '0.7rem',
                                          fontStyle: 'italic',
                                          mt: '1px',
                                        }}
                                      >
                                        Reason: {ele.additionalInfo.subVendorRejectedReason}
                                      </Typography>
                                    )}
                                  </Box>
                                )}

                              <Box className="tableBtn" id={`statusBtn-${ind}`}>
                                {props?.tabName === 'operation'
                                  ? props?.accessForOperations
                                    ? actionButton(ele.status, ele)
                                    : null
                                  : actionButton(ele.status, ele)}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      ) : val.key === 'isActive' ? (
                        <FormGroup className="switchButton justifyCenter">
                          <FormControlLabel
                            disabled={viewMoreIcon}
                            control={
                              <IOSSwitch
                                checked={ele[val.key]}
                                onChange={(e) => onCheckChange(e, ele, val.key, ind)}
                              />
                            }
                          />
                        </FormGroup>
                      ) : val.key === 'isMandatory' ? (
                        <StyledCheckbox
                          checked={ele[val.key]}
                          onChange={(e) => onCheckChange(e, ele, val.key, ind)}
                          disabled={viewMoreIcon}
                        />
                      ) : val.key === 'isExpiring' ? (
                        <StyledCheckbox
                          checked={ele[val.key]}
                          onChange={(e) => onCheckChange(e, ele, val.key, ind)}
                          disabled={viewMoreIcon}
                        />
                      ) : val.key === 'action' && props?.showApprovalAction ? (
                        <Box>
                          {ele?.approvalStatus?.toLowerCase() === 'pending' ? (
                            <>
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  props?.onApproveEmployee(ele, 'Approved');
                                }}
                              >
                                <TaskAltIcon sx={{ color: 'green' }} />
                              </IconButton>

                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  props?.onApproveEmployee(ele, 'Rejected');
                                }}
                              >
                                <HighlightOffIcon sx={{ color: 'red' }} />
                              </IconButton>
                            </>
                          ) : (
                            '-'
                          )}
                        </Box>
                      ) : val.key === 'action' ? (
                        <>
                          {' '}
                          {props?.accessForAssign ? (
                            <Button
                              className={`textTransformInherit fontNormal ${
                                ele.action.toLowerCase() + 'Btn'
                              }`}
                              variant="contained"
                              onClick={() => onClickTableVendor(ele)}
                            >
                              {ele[val.key]}
                            </Button>
                          ) : (
                            'No Access'
                          )}
                        </>
                      ) : val.key === 'Facilities' ? (
                        ele?.Facilities?.map((data) => (
                          <Chip
                            key={data?.id ?? data?.name}
                            className="chipSizeStyle"
                            avatar={<Avatar alt="Natacha" src={data?.img?.url} />}
                            label={data?.name}
                            variant="outlined"
                          />
                        ))
                      ) : val.key === 'tags' ? (
                        ele[val.key]?.toString()?.split(',')?.join(', ')
                      ) : val.key === 'starValue' ? (
                        <Box style={styleimg}>
                          <img
                            src={starImg}
                            alt="vendorimage"
                            className="width16"
                            style={stylename}
                          />
                          <span className="fw600">{ele[val.key] ? ele[val.key] : 0}</span>
                          <span>&nbsp;Rating</span>
                        </Box>
                      ) : val.key === 'availability' ? (
                        <Box>
                          <Typography variant={'body2'} className="colorPrimary">
                            {ele[val.key]}
                          </Typography>
                        </Box>
                      ) : val.key === 'icon' &&
                        handleMoreVertIcon(
                          ele['status'],
                          viewMoreIcon,
                          ele?.hasExtensionRequest,
                          ele,
                        ) ? (
                        <div className="flexend">
                          <IconButton onClick={(event) => handleMenuOpen(event, ele)}>
                            <div className="colorBlack">{<MoreVertIcon />}</div>
                          </IconButton>
                        </div>
                      ) : val.key === 'rating' ? (
                        <Box className="flex" alignItems={'baseline'}>
                          {ele.rating !== null && <img src={RatingStar} alt="RatingStar" />}
                          <Typography variant={'body2'} className="pl10">
                            {ele?.rating ? ele.rating : ''}
                          </Typography>
                        </Box>
                      ) : val.key === 'amount' ? (
                        <Box>
                          <Tooltip
                            title={'₹' + (Number(ele[val.key]) || 0)}
                            placement="bottom-start"
                          >
                            <Typography variant="body2">
                              {ele?.[val.key] && '₹'}&nbsp;
                              {abbreviateNumber(Number(ele[val.key]) || 0)}
                            </Typography>
                          </Tooltip>
                          <Typography
                            variant={'body4'}
                            component={'p'}
                            className={`${ele['rideStatus']}-status`}
                          >
                            {ele['rideStatus']}
                          </Typography>
                        </Box>
                      ) : val.key === 'preview' ? (
                        <Box
                          className="justifyCenter"
                          onClick={(e) => handlePreview(e, ele['tripUuid'], val?.label)}
                        >
                          <img src={Preview} alt="Preview" />
                        </Box>
                      ) : val.key === 'icon' ? (
                        // For icon column, show nothing for post-trip statuses
                        <Box></Box>
                      ) : (
                        <Box>
                          {val.key === 'subRoles' ? (
                            <Button
                              size="small"
                              variant="text"
                              color="primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                props?.onViewSubRoles?.(ele);
                              }}
                            >
                              VIEW
                            </Button>
                          ) : val.key === 'permissions' ? (
                            <Button
                              size="small"
                              variant="text"
                              color="primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                props?.onViewUpdatePermissions?.(ele);
                              }}
                            >
                              VIEW &amp; UPDATE
                            </Button>
                          ) : val.key === 'roleType' ? (
                            <Chip
                              label={ele[val.key]}
                              size="small"
                              color="primary"
                              variant="outlined"
                            />
                          ) : typeof ele[val.key] === 'object' && ele[val.key] !== null ? (
                            <Box>
                              {Object.entries(ele[val.key]).map(([key, value], idx) => (
                                <Typography
                                  key={idx}
                                  variant={'body2'}
                                  sx={{ fontSize: '12px', lineHeight: '1.6' }}
                                >
                                  {key}:{' '}
                                  {typeof value === 'object'
                                    ? JSON.stringify(value)
                                    : String(value)}
                                </Typography>
                              ))}
                            </Box>
                          ) : (
                            <Tooltip title={ele[val.key]} placement="bottom">
                              <Typography variant={'body2'}>{ele[val.key] || 'NA'}</Typography>
                            </Tooltip>
                          )}
                        </Box>
                      )}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))
            ) : (
              <TableRow>
                <StyledTableCell colSpan={data?.header?.length} align="center">
                  <CommonNoDataFound />
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {data?.body && data?.body?.length > 0 && data?.totalCount > 10 && (
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={Number(data?.totalCount)}
          rowsPerPage={Number(rowsPerPage)}
          page={Number(page)}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}

      <Popover
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleMenuClose()}
        className="tablePopover"
      >
        {moreIconData && moreIconData?.length > 0
          ? // Render the menu items using moreIconData if it is available
            moreIconData?.map((moreData, idx) => {
              const icon = moreIconSrc(moreData?.name);
              const isComponent = icon && typeof icon !== 'string';
              return (
                <MenuItem
                  onClick={(e) => onClickMoreIcon(e, selectedRow, moreData?.name)}
                  selected={selectedItem === moreData?.name}
                  key={idx}
                >
                  {isComponent ? (
                    <span className="mr10 alignItem">{icon}</span>
                  ) : (
                    icon?.length > 0 && (
                      <span className="mr10 alignItem">
                        <img src={icon} alt={moreData?.name} className="width20" />
                      </span>
                    )
                  )}
                  <Typography variant={'body2'} className="fw500">
                    {moreData?.name}
                  </Typography>
                </MenuItem>
              );
            })
          : // Render the custom menu items if moreIconData is not available
            getConditionalMenuItems(
              selectedRow?.status,
              selectedRow?.isIndividual,
              selectedRow?.hasExtensionRequest,
              selectedRow,
            )
              ?.filter((obj) => obj !== 'vip' && obj !== '')
              ?.map((moreData, idx) => {
                const icon = moreIconSrc(moreData);
                const isComponent = icon && typeof icon !== 'string';
                return (
                  <Box
                    key={idx}
                    className={
                      handleDisableEdit(props?.tabName, moreData, selectedRow?.scheduledTime) &&
                      'cursorDisabled'
                    }
                  >
                    <MenuItem
                      onClick={(e) => onClickMoreIcon(e, selectedRow, moreData)}
                      selected={selectedItem === moreData}
                      key={moreData}
                      className="customPointerEvents p10"
                      disabled={handleDisableEdit(
                        props?.tabName,
                        moreData,
                        selectedRow?.scheduledTime,
                      )}
                    >
                      {isComponent ? (
                        <span className="mr10 alignItem">{icon}</span>
                      ) : (
                        icon?.length > 0 && (
                          <span className="mr10 alignItem">
                            <img src={icon} alt={moreData} className="width20" />
                          </span>
                        )
                      )}
                      <Typography variant={'body2'} className="fw500">
                        {moreData}
                      </Typography>
                    </MenuItem>
                  </Box>
                );
              })}
      </Popover>
      {previewModal && (
        <PlacardModal
          open={previewModal}
          handleClose={handlePreviewClose}
          tripId={selectedTripId}
        />
      )}
    </div>
  );
};

export default CommonTable;
